import { render, staticRenderFns } from "./FileAttached.vue?vue&type=template&id=43bb415a&"
import script from "./FileAttached.vue?vue&type=script&lang=js&"
export * from "./FileAttached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports